import React from 'react';
import { Button } from '../Button';
import ChronometerComponent from '../Chronometer';
import HeaderComponent from '../Header';
import { Input } from '../Input';
import { ControlComponentProps, ControlComponentState } from './interface';
import './style.scss';
import { FaPlay, FaGripLinesVertical, FaRedo, FaStop } from "react-icons/fa";
import { DEFAULT_VALUES, MESSAGE, SOUNDS, validate } from '../../constants/constasts';

import { wrap } from 'comlink';

class ControlComponent extends React.Component<ControlComponentProps, ControlComponentState> {

    timeAnimation: number = 0;

    percentProgress = 0;

    constructor(props: ControlComponentProps) {
        super(props);
        this.state = {
            ...DEFAULT_VALUES,
            ms: 0,
            s: 0,
            m: 0,
            setInterv: () => { },
            status: 0,
            round: 0,
            message: '',
            disabledInput: false,
            timeAnimation: 0,
            progress: 0,
            totalExercise: '00:36:00',
            totalRest: '00:11:00',
            totalTime: '00:47:00',
            errors: [
                {
                    message: 'N\u00FAmero entero no mayor a 50',
                    limit: 50,
                    error: false
                }, {
                    message: 'Formato de hora incorrecto',
                    limit: 59,
                    error: false
                }, {
                    message: 'Formato de hora incorrecto',
                    limit: 59,
                    error: false
                }, {
                    message: 'Formato de hora incorrecto',
                    limit: 59,
                    error: false
                }, {
                    message: 'Formato de hora incorrecto',
                    limit: 59,
                    error: false
                }
            ]
        };
        // Not started = 0
        // started = 1
        // paused = 2
        // set ready = 3
    }

    calcAnimationTime = () => {
        let constant = 0.99723; //chrome
        if (navigator.userAgent.indexOf("Firefox") !== -1) {
            constant = 1.5923; //firefox
        }
        const { roundTime } = this.state;

        const array = roundTime.split(":")
        const seconds = +array[0] * 60;
        const time: number = seconds + (+array[1]);
        this.timeAnimation = time > 0 ? (constant * time) : 0;

        this.percentProgress = 100 / time;
    }

    calcTotal = () => {
        const { rounds, roundTime, restTime } = this.state;

        let totalExercise = "00:00:00";
        let rTime = "00:" + roundTime;
        for (let i = 0; i < +rounds; i++) {
            totalExercise = this.formatTime(this.timestrToSec(totalExercise) + this.timestrToSec(rTime));
        }

        let totalRest = "00:00:00";
        let reTime = "00:" + restTime;
        for (let i = 0, limit = +rounds - 1; i < limit; i++) {
            totalRest = this.formatTime(this.timestrToSec(totalRest) + this.timestrToSec(reTime));
        }

        const totalTime = this.formatTime(this.timestrToSec(totalExercise) + this.timestrToSec(totalRest));

        this.setState({ totalExercise, totalRest, totalTime })
    }

    timestrToSec = (timestr: any) => {
        var parts = timestr.split(":");
        return (parts[0] * 3600) +
            (parts[1] * 60) +
            (+parts[2]);
    }

    pad = (num: number) => {
        if (num < 10) {
            return "0" + num;
        } else {
            return "" + num;
        }
    }

    formatTime = (seconds: any) => {
        return [this.pad(Math.floor(seconds / 3600)),
        this.pad(Math.floor(seconds / 60) % 60),
        this.pad(seconds % 60),
        ].join(":");
    }

    playAudio(sound: string) {
        const audio = new Audio(sound)
        audio.load()
        const audioPromise = audio.play()
        if (audioPromise !== undefined) {
            audioPromise
                .then(() => {
                    // autoplay started
                })
                .catch((err: any) => {
                    // catch dom exception
                    console.info(err)
                })
        }
    }

    resetError = () => {
        let { errors } = this.state;
        errors.forEach(error => { error.error = false })
        this.setState({ errors });
    }

    setReady = () => {
        const { ready, status } = this.state;
        if (status === 0 || status !== 3) {
            const array = ready.split(":")
            const m: number = +array[0];
            const s: number = +array[1];
            this.calcAnimationTime();
            this.calcTotal();
            this.resetError();

            this.setState({ m, s }, async () => {
                //callback
                this.playAudio(SOUNDS[0].sound);

                const worker = new Worker('../../utils/workerChronometer', { name: 'runChronometerWorker', type: 'module' });
                const { runChronometer } = wrap<import('../../utils/workerChronometer').RunChronometerWorker>(worker)
                let state = {
                    ms: this.state.ms,
                    s: this.state.s,
                    m: this.state.m,
                }

                state = await runChronometer(state, 0);
                this.setState({ ...state })

                if (s > 0 || m > 0) {
                    const setInterv = setInterval(
                        async () => {
                            state = await runChronometer(state, 0);
                            this.setState({ ...state })
                            const { m, s } = state;
                            if (s <= 0 && m <= 0) {
                                this.initStart();
                            }
                        }, 10);
                    this.setState({ setInterv, status: 3, message: MESSAGE.ready, disabledInput: true, progress: 0 });
                }
            });
        }
    }

    initStart = () => {
        let { m } = this.state;
        const setInterv = this.state.setInterv;
        clearInterval(setInterv);
        let { roundTime } = this.state;
        let array = roundTime.split(":")
        const min = +array[0];
        const sec = +array[1];
        this.setState({ m: min, s: sec })
        setTimeout(() => {
            array = roundTime.split(":")
            m = +array[0];
            this.setState({ ms: 0, s: 0, m, setInterv: () => { }, status: 0, round: 1 },
                () => {
                    this.start();
                });
        }, 1000);
    }

    runReady = () => {
        let { ms, m, s } = this.state;

        if (s <= 0 && m <= 0) {
            const setInterv = this.state.setInterv;
            clearInterval(setInterv);
            let { roundTime } = this.state;
            this.setState({ m: 3, s: 0 })
            setTimeout(() => {
                const array = roundTime.split(":")
                m = +array[0];
                s = +array[1];
                this.setState({ ms: 0, s: 0, m, setInterv: () => { }, status: 0, round: 1 },
                    () => {
                        this.start();
                    });
            }, 1000);
        } else if (s <= 0) {
            s = 59;
            if (m > 0) {
                m--;
            }
        }
        if (ms === 100) {
            s--;
            ms = 0;
        }
        ms++;
        this.setState({ ms, m, s })
    }

    start = () => {
        this.playAudio(SOUNDS[1].sound);
        //this.runStart();
        const setInterv = setInterval(this.runStart, 10);

        const status = 1;
        this.setState({ setInterv, status, message: MESSAGE.box, timeAnimation: this.timeAnimation });
    }

    runStart = () => {
        let { ms, m, s, roundEndWarnign, progress } = this.state;

        if (s <= 0 && m <= 0) {
            const setInterv = this.state.setInterv;
            clearInterval(setInterv);

            let { restTime } = this.state;
            const array = restTime.split(":")
            m = +array[0];
            s = +array[1];
            this.setState({ ms: 0, s: 0, m, setInterv: () => { }, progress: 0 },
                () => {
                    this.reset();
                });
        } else if (s <= 0) {
            s = 59;
            if (m > 0) {
                m--;
            }
        }
        if (ms === 100) {
            s--;
            progress += this.percentProgress;
            this.roundEndWarnign(m, s, roundEndWarnign);
            ms = 0;
        }
        ms++;
        this.setState({ ms, m, s, progress })
    }

    roundEndWarnign = (m: number, s: number, toEnd: string) => {
        const minute: string = m < 10 ? `0${m}` : m.toString();
        const second: string = s < 10 ? `0${s}` : s.toString();
        const currentTime = `00:${minute}:${second}`;
        const endTime = `00:${toEnd}`;

        if (currentTime === endTime) {
            this.playAudio(SOUNDS[2].sound);
        }
    }

    reset = () => {
        const { round, rounds } = this.state;
        if (round >= +rounds) {
            this.playAudio(SOUNDS[1].sound);
            this.stop();
        } else {
            this.playAudio(SOUNDS[1].sound);
            const setInterv = setInterval(this.runRest, 10);
            this.setState({ setInterv, message: MESSAGE.rest, progress: 0 });
        }
    }

    runRest = () => {
        let { ms, m, s, round, ready, progress } = this.state;
        progress = 0;

        const array = ready.split(":")
        const mReady: number = +array[0];
        const sReady: number = +array[1];

        if (s === sReady && m === mReady) {
            this.playAudio(SOUNDS[0].sound);
        }

        if (s <= 0 && m <= 0) {
            const setInterv = this.state.setInterv;
            clearInterval(setInterv);

            let { roundTime } = this.state;
            const array = roundTime.split(":")
            m = +array[0];
            s = +array[1];
            round++;

            this.setState({ ms: 0, s: 0, m, setInterv: () => { }, round, progress: 0 },
                () => {
                    this.start();
                });
        } else if (s <= 0) {
            s = 59;
            if (m > 0) {
                m--;
            }
        }
        if (ms === 100) {
            s--;
            ms = 0;
        }
        ms++;
        this.setState({ ms, m, s, progress })
    }

    stop = () => {
        const setInterv = this.state.setInterv;
        clearInterval(setInterv);

        this.setState({
            ...DEFAULT_VALUES,
            ms: 0,
            s: 0,
            m: 0,
            setInterv: () => { },
            status: 0,
            round: 0,
            message: '',
            disabledInput: false,
            timeAnimation: 0,
            progress: 0
        })
    }

    pause = () => {
        const setInterv = this.state.setInterv;
        clearInterval(setInterv);
        this.setState({ status: 2, message: MESSAGE.pause })
    };

    resume = () => this.start();

    validFields = (field: string) => {
        let errors = this.state.errors;
        let valid = false;

        switch (field) {
            case 'rounds':
                const { rounds } = this.state
                valid = validate.isDigit(rounds);

                if (valid) {
                    valid = +rounds > 0 && +rounds <= errors[0].limit!
                    if (valid) {
                        this.setState({ rounds })
                    } else {
                        this.setState({ rounds: DEFAULT_VALUES.rounds });
                    }
                } else {
                    this.setState({ rounds: DEFAULT_VALUES.rounds });
                }

                errors[0].error = !valid;

                break;

            case 'roundTime':
                const { roundTime } = this.state
                valid = validate.isTime(roundTime);

                if (valid) {
                    valid = `00:${roundTime}` >= '00:00:30';
                    if (valid) {
                        this.setState({ roundTime })
                    } else {
                        this.setState({ roundTime: DEFAULT_VALUES.roundTime });
                    }
                } else {
                    this.setState({ roundTime: DEFAULT_VALUES.roundTime });
                }

                errors[1].error = !valid;

                break;

            case 'roundEndWarnign':
                const { roundEndWarnign } = this.state
                const rTime = this.state.roundTime;
                valid = validate.isTime(roundEndWarnign);

                if (valid) {
                    valid = `00:${rTime}` > `00:${roundEndWarnign}`
                    if (valid) {
                        this.setState({ roundEndWarnign })
                    } else {
                        this.setState({ roundEndWarnign: DEFAULT_VALUES.roundEndWarnign });
                    }
                } else {
                    this.setState({ roundEndWarnign: DEFAULT_VALUES.roundEndWarnign });
                }

                errors[4].error = !valid;

                break;

            case 'restTime':
                const { restTime } = this.state
                valid = validate.isTime(restTime);

                if (valid) {
                    valid = `00:${restTime}` >= '00:00:10';
                    if (valid) {
                        this.setState({ restTime })
                    } else {
                        this.setState({ restTime: DEFAULT_VALUES.restTime });
                    }
                } else {
                    this.setState({ restTime: DEFAULT_VALUES.restTime });
                }

                errors[2].error = !valid;

                break;

            case 'ready':
                const { ready } = this.state
                valid = validate.isTime(ready);

                if (valid) {
                    valid = `00:${ready}` >= '00:00:10';
                    if (valid) {
                        this.setState({ ready })
                    } else {
                        this.setState({ ready: DEFAULT_VALUES.ready });
                    }
                } else {
                    this.setState({ ready: DEFAULT_VALUES.ready });
                }

                errors[3].error = !valid;

                break;

            default:
                break;
        }

        this.setState({ errors })
    }

    validTime = () => {

    }

    render() {
        const { rounds, roundTime, restTime, ready, roundEndWarnign, m, s, status, round,
            message, disabledInput, timeAnimation, progress, errors, totalExercise,
            totalRest, totalTime } = this.state;

        return (
            <div className='d-flex'>
                <div className="chronometer-container">
                    <ChronometerComponent m={m} s={s} rounds={rounds} round={round} status={status}
                        message={message} timeAnimation={timeAnimation} progress={progress} />
                    <div className='container-buttons'>
                        {status === 0 ?
                            <div className='container-buttons'>
                                <Button type='primary' onClick={this.setReady} icon={< FaPlay className='mr-5' />}>
                                    Iniciar
                                </Button>
                            </div> : ""
                        }
                        {status === 3 ?
                            <div className='container-buttons'>
                                <Button type='primary' onClick={this.stop}
                                    icon={< FaStop className='mr-5' />}>Detener</Button>
                            </div> : ""
                        }
                        {status === 1 ?
                            <div className='container-buttons'>
                                <Button type='primary' onClick={this.pause}
                                    icon={< FaGripLinesVertical className='mr-5' />}>Pausar</Button>
                                <Button type='primary' onClick={this.stop}
                                    icon={< FaStop className='mr-5' />}>Detener</Button>
                            </div> : ""
                        }
                        {status === 2 ?
                            <div className='container-buttons'>
                                <Button type='primary' onClick={this.resume}
                                    icon={< FaRedo className='mr-5' />}>Reiniciar</Button>
                                <Button type='primary' onClick={this.stop}
                                    icon={< FaStop className='mr-5' />}>Detener</Button>
                            </div> : ""
                        }
                    </div>
                </div>
                <div className={`control-container control-container-${disabledInput ? 'disabled' : 'active'}`}>
                    <HeaderComponent />
                    <h2>Panel de Control</h2>

                    <Input
                        label="Rounds"
                        value={rounds}
                        classFlex='d-flex-space'
                        disabled={disabledInput}
                        maxLength={2}
                        onChange={(e) => this.setState({ rounds: e.currentTarget.value })}
                        onBlur={() => { this.validFields('rounds'); }}
                        error={errors[0].error ? errors[0].message : ''}
                    />

                    <Input
                        label="Duraci&oacute;n"
                        value={roundTime}
                        classFlex='d-flex-space'
                        disabled={disabledInput}
                        maxLength={5}
                        onChange={(e) => this.setState({ roundTime: e.currentTarget.value })}
                        //onBlur={() => {(e:any) => this.setState({ field:'roundTime' }); this.validFields;}}
                        // onBlur={() => {(e:any) => this.setState({ field:'roundTime' },
                        // () => {
                        //     this.validFields('');
                        // });}}
                        onBlur={() => { this.validFields('roundTime'); }}
                        error={errors[1].error ? errors[1].message : ''}
                    />
                    <Input
                        label="Descanso"
                        value={restTime}
                        classFlex='d-flex-space'
                        disabled={disabledInput}
                        maxLength={5}
                        onChange={(e) => this.setState({ restTime: e.currentTarget.value })}
                        onBlur={() => { this.validFields('restTime'); }}
                        error={errors[2].error ? errors[0].message : ''}
                    />
                    <Input
                        label="Prepararse"
                        value={ready}
                        classFlex='d-flex-space'
                        disabled={disabledInput}
                        maxLength={5}
                        onChange={(e) => this.setState({ ready: e.currentTarget.value })}
                        onBlur={() => { this.validFields('ready'); }}
                        error={errors[3].error ? errors[0].message : ''}
                    />
                    <Input
                        label="Alerta de fin"
                        value={roundEndWarnign}
                        classFlex='d-flex-space'
                        disabled={disabledInput}
                        maxLength={5}
                        onChange={(e) => this.setState({ roundEndWarnign: e.currentTarget.value })}
                        onBlur={() => { this.validFields('roundEndWarnign'); }}
                        error={errors[4].error ? errors[0].message : ''}
                    />
                    <div className="Table f-20">
                        <div className="Row">
                            <div className="Cell">
                                <div>Tiempo de rounds:</div>
                            </div>

                            <div className="Cell">
                                <div>{totalExercise}</div>
                            </div>
                        </div>

                        <div className="Row">
                            <div className="Cell">
                                <div>Tiempo de descanso:</div>
                            </div>

                            <div className="Cell">
                                <div>{totalRest}</div>
                            </div>
                        </div>

                        <div className="Row">
                            <div className="Cell">
                                <div>Tiempo total:</div>
                            </div>

                            <div className="Cell">
                                <div>{totalTime}</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        );
    }
}

export default ControlComponent;
